// noinspection JSUnresolvedVariable
const handlePriceCommasFormat = (price) => {
    return String(price).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}
const handleAmdPrice = ({code: currCode}, price = 0) => {
    const currentCurrCodeIsAmd = currCode.toLowerCase() === "amd";
    if (!currentCurrCodeIsAmd) {
        return Number(price).toFixed(2)
    }
    return +price
}

function Get_All_Forms({locale}, models) {
    return new Promise((resolve) => {
        models
            .forms
            .find()
            .then((forms) => {
                resolve({data: forms});
            })
            .catch((err) => reject(err));
    });
}

function Get_Form_By_Id({form_id, locale}, models) {
    return new Promise((resolve, reject) => {
        models
            .forms
            .findOne({id: form_id})
            .then((form) => {
                resolve({data: form});
            })
            .catch((err) => reject(err));
    });
}

async function Get_Shipping_Cities({locale, selectedRate}, models) {
    const {exchange_rate: {rate = 1} = {}} = selectedRate || {}
    const cities = await models.cities.find({}).lean() || [];
    return cities.map(({ _id, created_at, updated_at, translations, price, ...otherInfo } = {}) => {
        const nameIntlObj = translations?.find(elem => elem?.locale === locale) || null;
        if (nameIntlObj) {
            return {
                ...otherInfo,
                translations,
                name: nameIntlObj?.name,
                price: handlePriceCommasFormat(handleAmdPrice(selectedRate, +price * rate))
            }
        }
        return otherInfo
    })
        .sort((a, b) => a.position - b.position)
}

async function Get_Shipping_Pick_Address({locale}, models) {
    const cities = await models.pickup_addresses.find({}).lean() || [];
    return cities.map(({ _id, created_at, updated_at, translations, price, ...otherInfo } = {}) => {
        const nameIntlObj = translations?.find(elem => elem?.locale === locale) || null;
        if (nameIntlObj) {
            return {
                ...otherInfo,
                translations,
                name: nameIntlObj?.name,
            }
        }
        return otherInfo
    })
        .sort((a, b) => a.position - b.position)
}

module.exports = {
    Get_All_Forms,
    Get_Form_By_Id,
    Get_Shipping_Cities,
    Get_Shipping_Pick_Address
};